import React from "react";
import { createRoot } from "react-dom/client";

declare var numPagesString: string; // eslint-disable-line no-var
let numPages = parseInt(numPagesString);

declare var currentPageString: string; // eslint-disable-line no-var
let currentPage = parseInt(currentPageString);

declare var pageRangeURLs: Array<{ page_num: number; url: string }>; // eslint-disable-line no-var

const PAGES_EITHER_SIDE_TO_DISPLAY = 2;

const BackArrow = () => (
  <svg
    className="back pointer"
    width="25"
    height="14"
    viewBox="0 0 25 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.3359 5.82189L3.91557 5.82189L8.27384 1.46565L6.84178 -7.64694e-07L0.734901 6.10687L0.0020749 6.8397L0.734901 7.57252L6.84178 13.6794L8.27282 12.2138L3.91557 7.85751L24.3359 7.85751L24.3359 5.82189Z"
      fill="#252E4B"
    />
  </svg>
);

const ForwardArrow = () => (
  <svg
    className="forward pointer"
    width="25"
    height="14"
    viewBox="0 0 25 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.54483e-07 5.82189L20.4204 5.82189L16.0621 1.46565L17.4942 -7.64694e-07L23.601 6.10687L24.3339 6.8397L23.601 7.57252L17.4942 13.6794L16.0631 12.2138L20.4204 7.85751L3.43463e-07 7.85751L2.54483e-07 5.82189Z"
      fill="#252E4B"
    />
  </svg>
);

const Numbers = () => (
  <>
    {currentPage - PAGES_EITHER_SIDE_TO_DISPLAY > 1 ? (
      <>
        <a
          href={pageRangeURLs[0].url}
          className={`${
            pageRangeURLs[0].page_num === currentPage ? "green" : "black"
          } pointer`}
        >
          {pageRangeURLs[0].page_num}
        </a>
        {currentPage - PAGES_EITHER_SIDE_TO_DISPLAY > 2 ? (
          <div className="pages-ellipses">...</div>
        ) : (
          <></>
        )}
      </>
    ) : (
      <></>
    )}

    {pageRangeURLs
      .slice(
        Math.max(currentPage - PAGES_EITHER_SIDE_TO_DISPLAY - 1, 0),
        Math.min(currentPage + PAGES_EITHER_SIDE_TO_DISPLAY, numPages),
      )
      .map((page) => (
        <a
          key={page.page_num}
          href={page.url}
          className={`${
            page.page_num === currentPage ? "green" : "black"
          } pointer`}
        >
          {page.page_num}
        </a>
      ))}
    {currentPage + PAGES_EITHER_SIDE_TO_DISPLAY < numPages ? (
      <>
        {currentPage + PAGES_EITHER_SIDE_TO_DISPLAY < numPages - 1 ? (
          <div className="pages-ellipses">...</div>
        ) : (
          <></>
        )}
        <a
          href={pageRangeURLs[pageRangeURLs.length - 1].url}
          className={`${
            pageRangeURLs[pageRangeURLs.length - 1].page_num === currentPage
              ? "green"
              : "black"
          } pointer`}
        >
          {pageRangeURLs[pageRangeURLs.length - 1].page_num}
        </a>
      </>
    ) : (
      <></>
    )}
  </>
);

const Pagination = () => {
  return (
    <div className="shared-redesign-styles pagination">
      <a
        className={`pagintion-arrow ${
          currentPage === 1 ? "disabled-pagination-button" : ""
        }`}
        {...(currentPage > 1
          ? // Using currentPage-2 below as the variable goes from 1 to numPages (not 0 to numPages-1)
            { href: pageRangeURLs[currentPage - 2].url }
          : {})}
      >
        <BackArrow />
      </a>

      <Numbers />

      <a
        className={`pagintion-arrow ${
          currentPage === numPages ? "disabled-pagination-button" : ""
        }`}
        {...(currentPage < numPages
          ? // Using currentPage below as the variable goes from 1 to numPages (not 0 to numPages-1)
            { href: pageRangeURLs[currentPage].url }
          : {})}
      >
        <ForwardArrow />
      </a>
    </div>
  );
};

document.addEventListener("DOMContentLoaded", () => {
  createRoot(document.getElementById("pagination-container")!).render(
    <Pagination />,
  );
});
